import { useUserEventLogger } from '@repo/tracking-service';
import { Button, Guide } from '@zenterprise-inc/ui';

import FillRegisterQuick from '@/assets/illust-icons/fill-register-quick.svg';

const CorporationHometaxGuide = ({ handleClick }: { handleClick: () => void }) => {
  const { sendClickEvent } = useUserEventLogger();
  return (
    <Guide>
      <Guide.ImageArea>
        <FillRegisterQuick />
      </Guide.ImageArea>
      <Guide.TextArea>
        <Guide.Title titleType="large" className="text-gray-900">
          홈택스 아이디로 조회하기
        </Guide.Title>
        <Guide.Description className="body-16">
          인증서 없이
          <br />
          빠르게 조회해요.
        </Guide.Description>
      </Guide.TextArea>
      <Guide.ButtonArea>
        <Button.Box
          size="large"
          state="primary"
          onClick={() => {
            sendClickEvent('corps-selectauth_hometaxid_large');
            handleClick();
          }}
        >
          30초 만에 조회하기
        </Button.Box>
      </Guide.ButtonArea>
    </Guide>
  );
};

export default CorporationHometaxGuide;
